import InfoIcon from "@public/info-icon.svg";
import { useAtomValue } from "jotai";
import Image from "next/image";
import { selectedStyleAtom } from "../constants/budget-atom";
import { kBudgetConfig } from "../constants/budget-translations";
import { useMemo } from "react";

const BudgetChatHeader: React.FC<{ showOldDataDisclaimer?: boolean }> = ({
  showOldDataDisclaimer = false,
}) => {
  const selectedStyle = useAtomValue(selectedStyleAtom);
  const copies = useMemo(() => kBudgetConfig(selectedStyle), [selectedStyle]);

  if (showOldDataDisclaimer) {
    return (
      <>
        <div className="rounded-xl bg-warning px-4 py-2">
          <p className="text-center font-sen text-sm text-white">
            {copies.kBudgetChatOldDataDisclaimer}
          </p>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="flex flex-row items-center space-x-2">
          <div className="mt-2">
            <Image src={InfoIcon} alt="info-icon" height={20} width={20} />
          </div>
          <p className="font-sen text-sm font-normal text-disabled">
            {copies.kBudgetChatDisclaimer}
          </p>
        </div>
      </>
    );
  }
};

export default BudgetChatHeader;
